import { cn, Page } from '@autone/ui';
import {
  TopNavbar,
  TopNavBarSubtitle,
  TopNavBarTitle,
  TopNavBarTitlesWrapper,
} from '@autone/ui-next/components';
import { type HTMLAttributes } from 'react';

interface AssortmentLayoutProps extends HTMLAttributes<HTMLDivElement> {
  headerText: string;
  subHeaderText?: React.ReactNode;
  subHeaderExtras?: React.ReactNode;
  leftExtras?: React.ReactNode;
  rightExtras?: React.ReactNode;
}

export const AssortmentLayout = ({
  headerText,
  subHeaderText,
  subHeaderExtras,
  leftExtras,
  rightExtras,
  className,
  children,
  ...props
}: AssortmentLayoutProps) => {
  return (
    <div className="flex flex-col">
      <TopNavbar className="flex items-center gap-2">
        {leftExtras}
        <TopNavBarTitlesWrapper>
          <TopNavBarTitle>{headerText}</TopNavBarTitle>
          <div className="flex flex-row gap-0.5 items-center">
            <TopNavBarSubtitle>{subHeaderText}</TopNavBarSubtitle>
            {subHeaderExtras}
          </div>
        </TopNavBarTitlesWrapper>
        <div className="ml-auto">{rightExtras}</div>
      </TopNavbar>
      <Page title={headerText}>
        <main
          className={cn('flex flex-col w-full items-center ', className)}
          {...props}
        >
          <div className="flex flex-col gap-6 w-full">{children}</div>
        </main>
      </Page>
    </div>
  );
};
